import { useState, CSSProperties } from "react";
import UploadFileTab from "./UploadFileTab";
import MatchFileTab from "./MatchFileTab";
import FinalizeTab from "./FinalizeTab";
import TopBar from "components/shareable/TopBar/TopBar";
import { NextButton } from "./styles";
import { useHistory } from "react-router-dom";
import useScreen from "Hooks/useScreen";
import TabSymphony from "elements/TabSymphony";
import useUploadEmailsByCsv from "Hooks/useUploadEmailsByCsv";
import TabsSymphony, { TabItem } from "elements/TabsSymphony";
import PrevNextFooter from "elements/PrevNextFooter";
import PageSymphony from "elements/PageSymphony";
import Icon from "elements/Icon";

export enum STEPS {
    UPLOAD_FILE = "upload_file",
    MATCH_FILE = "match_file",
    FINALIZE = "finalize",
}

const { UPLOAD_FILE, MATCH_FILE, FINALIZE } = STEPS;

const UPLOAD_EMAILS_TABS: TabItem[] = [
    { title: "Upload file", id: UPLOAD_FILE },
    { title: "Match file", id: MATCH_FILE },
    { title: "Finalize", id: FINALIZE },
];

const UploadEmailsByCsv = () => {
    const history = useHistory();
    const { mobileView } = useScreen();
    const {
        match,
        mappedColumns,
        isLoadingUploadEmails,
        setIsLoadingUploadEmails,
        importFans
    } = useUploadEmailsByCsv();

    const { source } = match;

    const [showError, setShowError] = useState(false);
    const [isConsentConfirmed, setIsConsentConfirmed] = useState(false);
    const [selectedUploadEmailsTab, setSelectedUploadEmailsTab] = useState<TabItem>(UPLOAD_EMAILS_TABS[0]);

    const handleClickBackButton = () => {
        if (selectedUploadEmailsTab.id === FINALIZE) {
            setSelectedUploadEmailsTab(UPLOAD_EMAILS_TABS[1]);
        } else if (selectedUploadEmailsTab.id === MATCH_FILE) {
            setSelectedUploadEmailsTab(UPLOAD_EMAILS_TABS[0]);
        } else {
            history.push('/fans');
        }
    };

    const handleClickNextButton = async () => {
        if (selectedUploadEmailsTab.id === UPLOAD_FILE) {
            setSelectedUploadEmailsTab(UPLOAD_EMAILS_TABS[1]);
            return;
        }

        if (selectedUploadEmailsTab.id === MATCH_FILE) {
            setSelectedUploadEmailsTab(UPLOAD_EMAILS_TABS[2]);
            return;
        }

        try {
            await importFans();
            history.push({
                pathname: '/fans',
                state: { importingFans: true }
            });
        } catch (err) {
            setShowError(true);
            console.error('Error importing fans:', err);
        }
    }

    const renderMobileViewMessage = () => {
        return (
            <div style={sty.mobileUploadContainer}>
                <Icon className="mobileUploadIcon" icon="computer" style={sty.mobileUploadIcon} />
                <h2 style={sty.mobileUploadTitle}>
                    Switch to Desktop for Fanbase Import
                </h2>
                <p style={sty.mobileUploadDescription}>
                    Importing your fanbase requires advanced tools that are available on larger screens. Please use a desktop to complete this process.
                </p>
            </div>
        )
    }

    const renderDesktopView = () => {
        return (
            <>

                {/* <CustomStepper
                        className="uploadEmailsByCsvCustomStepper"
                        activeStep={UPLOAD_EMAILS_TABS.map(({ name }) => name).indexOf(selectedUploadEmailsTab as STEPS)}
                        steps={UPLOAD_EMAILS_TABS}
                        stepButtonsProps={{
                            className: "uploadEmailsByCsvStepButtons",
                            handleClickBackButton,
                            handleClickNextButton,
                            nextButtonLabel: isEqual(selectedUploadEmailsTab, FINALIZE) ? `Import Fans` : 'Next',
                            nextButtonWidth: isEqual(selectedUploadEmailsTab, FINALIZE) ? 'fit-content' : undefined,
                            disableNextButton: !isConsentConfirmed
                        }}
                    /> */}
                <TabsSymphony
                    className="uploadEmailsByCsvTabsSymphony"
                    tabs={UPLOAD_EMAILS_TABS}
                    selectedTab={selectedUploadEmailsTab}
                    // onChange={(tab) => setSelectedUploadEmailsTab(tab as TabItem)}
                    type="numbers"
                    style={{ maxWidth: 560 }}
                    isHeader
                />
                <PageSymphony
                    className="uploadEmailsByCsvMainContentContainer"
                    isContent
                    isStepper
                >
                    <TabSymphony className="uploadFileTab" visible={selectedUploadEmailsTab.id === UPLOAD_FILE}>
                        <UploadFileTab
                            isConsentConfirmed={isConsentConfirmed}
                            setIsConsentConfirmed={setIsConsentConfirmed}
                        />
                    </TabSymphony>
                    <TabSymphony className="matchFileTab" visible={selectedUploadEmailsTab.id === MATCH_FILE}>
                        <MatchFileTab
                            selectedStep={selectedUploadEmailsTab.id as STEPS}
                        />
                    </TabSymphony>
                    {selectedUploadEmailsTab.id === FINALIZE &&
                        <TabSymphony className="finalizeTab" visible={selectedUploadEmailsTab.id === FINALIZE}>
                            <FinalizeTab
                                selectedStep={selectedUploadEmailsTab.id as STEPS}
                                showError={showError}
                                setShowError={setShowError}
                            />
                        </TabSymphony>
                    }
                </PageSymphony>

                <PrevNextFooter
                    className="uploadEmailsByCsvPrevNextFooter"
                    tabs={UPLOAD_EMAILS_TABS}
                    currentTab={selectedUploadEmailsTab}
                    handlePrevTab={handleClickBackButton}
                    handleNextTab={handleClickNextButton}
                    nextButtonLabel={selectedUploadEmailsTab.id === FINALIZE ? `Import Fans` : 'Next'}
                    isNextButtonDisabled={!isConsentConfirmed}
                />
            </>
        )
    }

    if (showError) {
        return (
            <div className="uploadEmailsByCsvErrorContainer" style={sty.errorContainer}>
                <div className="uploadEmailsByCsvErrorTitle" style={sty.errorTitle}>
                    There was an error importing your fans.
                </div>
                <div className="uploadEmailsByCsvErrorMessage" style={sty.errorMessage}>
                    An error occurred. Try again later.
                </div>
                <div className="uploadEmailsByCsvErrorButton" style={sty.errorButton}>
                    <NextButton onClick={() => history.push("/fans")}>Try Again</NextButton>
                </div>
            </div>
        );
    }

    return (
        <div className="uploadEmailsByCsvComponent" style={sty.uploadEmailsByCsvComponent}>
            <TopBar
                className='uploadEmailsByCsvTopBar'
                title="Import a new fanbase"
                isCloseIcon
                handleClose={() => history.push('/fans')}
            />
            {mobileView ?
                renderMobileViewMessage()
                :
                renderDesktopView()
            }
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    uploadEmailsByCsvComponent: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '40px auto'
    },
    errorTitle: {
        fontSize: '32px',
        fontWeight: 500
    },
    errorMessage: {
        color: '#707070',
        padding: '32px 0px 0px 0px'
    },
    errorButton: {
        maxWidth: '116px',
        padding: '32px 0px 0px 0px'
    },
    loadingContainer: {
        margin: '92px auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        textAlign: 'center'
    },
    mobileUploadContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        border: '1px solid #e0e0e0',
        borderRadius: 8,
        padding: 20,
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#fff'
    },
    mobileUploadIcon: {
        padding: 12,
        width: 64,
        height: 64,
        backgroundColor: '#EDECF2',
        filter: 'grayscale(100%) brightness(1.2) contrast(0.8)',
        borderRadius: 100,
        marginBottom: 16,
        marginTop: 16
    },
    mobileUploadTitle: {
        fontSize: 18,
        fontWeight: 600,
        margin: '0 0 10px'
    },
    mobileUploadDescription: {
        fontSize: 14,
        color: '#6b6b6b',
        margin: 0
    },
}

export default UploadEmailsByCsv;
